// src/utils/serviceSearchKey.ts
import type { SearchFilterOption } from "../api/service.network.ts";

export function buildServiceSearchKey(opt: SearchFilterOption) {
  const keyObj = {
    keyword: (opt.searchKeyword ?? "").trim(),
    min_price: opt.filterMinPrice ?? 0,
    max_price: opt.filterMaxPrice ?? 0,
    rating: opt.filterRating ?? null,
    per_page: opt.perPage ?? 20,
    category_ids: [...(opt.selectMainCategories ?? [])],
    sub_category_ids: [...(opt.selectSubCategories ?? [])],
    location_tags: [...(opt.selectLocationTags ?? [])],
  };

  return JSON.stringify(keyObj);
}
